/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('ImportCtrl', [
        "$scope", "$dialog", "$rootScope", "$filter", "$log","Customer", "CustomerSrv", "CustomerData", "CustomerView",
        "HumanResourceData", "PhysicalResourceData","Booking", "CategoryData", "BookingService", "DayData", "Day",
        "Period", "Transaction", "BookingSrv", "ServerSrv", "Format","ProductCategoryView","ProductCategoryData",
        "ProductView","SupplierData","SupplierView", "ImageData","CompanyImageData","CategoryView", "ServiceView",
        "VatData","VatView", "ProductData","OptInOutView","PhoneFormat",
        "gettextCatalog", "BasicAuthRole", "Constants", "MarketplaceSrv",
    function($scope,$dialog,$rootScope,$filter,$log,Customer,CustomerSrv,CustomerData, CustomerView,HumanResourceData,
             PhysicalResourceData,Booking,CategoryData,BookingService,DayData,Day,Period,Transaction, BookingSrv,
             ServerSrv,Format,ProductCategoryView,ProductCategoryData,ProductView,SupplierData,SupplierView, ImageData,
             CompanyImageData,CategoryView,ServiceView,VatData,VatView, ProductData, OptInOutView,PhoneFormat,
             gettextCatalog, BasicAuthRole, Constants, MarketplaceSrv)
    {

        $scope.dd =
            {
                view :
                    {
                        vatsView :[],
                        customersImportView : [],
                        customersDisplayView : [],
                        customersSavedView : [],
                        bookingsImportView : [],
                        bookingsDisplayView : [],
                        bookingsSavedView : [],
                        waitingForLoading : false,
                        productCategoryRootView : null,
                        serviceCategoryRootView : null,
                        suppliersView : [],
                        suppliersImportView : [],
                        suppliersSavedView : [],
                        cProductCategoryView : null,
                        currentServiceCategoryView : null,
                        savingNumber : 0,
                        saving :false,
                        logs : [],
                        errors : [],
                        tab :1,
                        updateMode : true,
                        partnerActivationSettings: [],
                        serviceImportReady: false,
                        serviceSaveComplete: false,
                        tooManyServicesImported: false,
                        maxServicesForCompany: Constants.MAX_SERVICES_FOR_COMPANY
                    },
                customersImportByCsv : [],
                bookingsImportByCsv : [],
                productsImportByCsv : [],
                servicesImportByCsv : [],
                customersCommentImportByCsv :[],
                displaySubConf : 1,
                basicAuthRole: BasicAuthRole,
                marketplaceData: {
                    loaded: false,
                    services: []
                },
                settings : [],
                activationByPartnerLabel : {}
            };
        $scope.$watch('ad.dataLoaded', function(newValue, oldValue)
        {
            if (newValue)
            {
                var vats = VatData.getActiveList();
                for (var i=0;i<vats.length;i++)
                    if(vats[i].isUsable)
                        $scope.addVatView(new VatView(vats[i],VatData.getIndexOf(vats[i])));

                var suppliers = SupplierData.getActiveList();
                for (var i=0;i<suppliers.length;i++)
                    $scope.addSupplierView(new SupplierView(suppliers[i],SupplierData.getIndexOf(suppliers[i]),$scope));
                $scope.dd.view.imagesView = ImageData.getActiveList("");
                $scope.dd.view.companyImagesView = CompanyImageData.companyImages;
                $scope.dd.view.productCategoryRootView = new ProductCategoryView(ProductCategoryData.categoryRoot,ProductCategoryData.getIndexOf(ProductCategoryData.categoryRoot),null,$scope);// categoryRoot index  = 0
                $scope.dd.view.productCategoryRootView.label = "Racine";
                $scope.dd.view.cProductCategoryView = $scope.dd.view.productCategoryRootView;
                $scope.dd.view.serviceCategoryRootView = new CategoryView(CategoryData.categoryRoot,CategoryData.getIndexOf(CategoryData.categoryRoot),null,$scope);// categoryRoot index  = 0
                $scope.dd.view.serviceCategoryRootView.label = "Racine";
                $scope.dd.view.currentServiceCategoryView = $scope.dd.view.serviceCategoryRootView;
                $scope.initializePartnerActivationSettings();
            }
        });

        $scope.initializePartnerActivationSettings = function() {
            $scope.dd.view.partnerActivationSettings.push({
                displayRadio: $scope.ad.addons.sub.optionLeCiseau,
                role: BasicAuthRole.LE_CISEAU_ROLE.role,
                partner: BasicAuthRole.LE_CISEAU_ROLE.label,
                radioLabel: "Activer les nouvelles prestations sur la marketplace " + $scope.ad.brand.marketplace.url.shortWebsite + ", avec promotion",
                activateOnImport: false
            });
        };

        $scope.isPartnerActivationSettingsActive = function (role) {
            if (role) {
                for (let i = 0; i < $scope.dd.view.partnerActivationSettings.length; i++) {
                    if ($scope.dd.view.partnerActivationSettings[i].role === role) {
                        return $scope.dd.view.partnerActivationSettings[i].activateOnImport;
                    }
                }
            }
            return false;
        };

        $scope.getHasHr = function ()
        {
            return true;
        };
        $scope.getVatView = function (vat)
        {
            for(var i=0;i<$scope.dd.view.vatsView.length;i++)
                if ($scope.dd.view.vatsView[i].getModel()===vat)
                    return $scope.dd.view.vatsView[i];

            // Not found : instanciate (could be a deleted)
            var vatView = new VatView(vat,VatData.getIndexOf(vat));
            if (!vat.isDeleted)
                $scope.dd.view.vatsView.push(vatView);
            return vatView;
        };
        $scope.getVatViewByTax = function (tax)
        {
            for(var i=0;i<$scope.dd.view.vatsView.length;i++)
                if ($scope.dd.view.vatsView[i].getModel().tax==tax)
                    return $scope.dd.view.vatsView[i];
            return null;
        };
        $scope.getDefaultVatView = function () {
            for (var i = 0; i < $scope.dd.view.vatsView.length; i++)
                if ($scope.dd.view.vatsView[i].isDefault)
                    return $scope.dd.view.vatsView[i];

        }
        $scope.addVatView = function (vatView)
        {
            var index = $scope.dd.view.vatsView.indexOf(vatView);
            if (index==-1)
                $scope.dd.view.vatsView.push(vatView);
        };
        $scope.addSupplierView = function (supplierView)
        {
            var index = $scope.dd.view.suppliersView.indexOf(supplierView);
            if (index==-1)
                $scope.dd.view.suppliersView.push(supplierView);
        };
        $scope.getSupplierView = function (supplier)
        {
            //must loop....
            for(var i=0;i<$scope.dd.view.suppliersView.length;i++)
                if ($scope.dd.view.suppliersView[i].getModel()===supplier)
                    return $scope.dd.view.suppliersView[i];

            // Not found : instanciate (could be a deleted customer)
            var supplierView = new SupplierView(supplier,SupplierData.getIndexOf(supplier),$scope);
            if (!supplier.isDeleted)
                $scope.dd.view.suppliersView.push(supplierView);
            return supplierView;
        };
        $scope.getSupplierViewByLabel = function (supplierLabel)
        {
            for(var i=0;i<$scope.dd.view.suppliersView.length;i++)
                if ($scope.dd.view.suppliersView[i].label==supplierLabel)
                    return $scope.dd.view.suppliersView[i];
            for(var i=0;i<$scope.dd.view.suppliersImportView.length;i++)
                if ($scope.dd.view.suppliersImportView[i].label==supplierLabel)
                    return $scope.dd.view.suppliersImportView[i];
            var supplierView = new SupplierView(null,-1,$scope);
            supplierView.label = supplierLabel;
            $scope.dd.view.suppliersImportView.push(supplierView);
            return supplierView;
        };
        $scope.getCfgClass   = function(confItem,className)
        {
            if (confItem==$scope.dd.displaySubConf)
                return className;
            return "";
        };
        $scope.getServiceView = function (service)
        {
            //Assume view index = model index
            var serviceView = $scope.dd.view.serviceCategoryRootView.getServiceView(service)
            return serviceView;
        };
        $scope.checkPhoneNumberValidity = function(phoneNumber, checkMobile, region){
            let validPhone;
            let isMobileNumber = PhoneFormat.isMobileNumber(phoneNumber, region);
            if(PhoneFormat.isValid(phoneNumber, region) && (!checkMobile || (checkMobile && isMobileNumber))){
                validPhone = PhoneFormat.formatNumberWithInternationalFormat(phoneNumber, region);
            }
            else{
                if(phoneNumber.startsWith("00")) {
                    phoneNumber = PhoneFormat.INTERNATIONAL_PREFIX + phoneNumber.substring(2, phoneNumber.length);
                }
                let code = PhoneFormat.getCountryFromNumber(phoneNumber, checkMobile);
                if(code && code !== "" && code !== "unknow" && code !== region) {
                    validPhone = $scope.checkPhoneNumberValidity(phoneNumber, checkMobile, code);
                }
            }

            return validPhone;
        };

        $scope.isBlank = function (str) {
            return (!str || /^\s*$/.test(str));
        };

        $scope.trimAndUpperFirst = function (str) {
            if (!str) {
                return str;
            }
            return str
                .trim()
                .toLowerCase()
                .replace(/(?:^|\s)\S/g,
                    function (a) {
                        return a.toUpperCase();
                    });
        };

        $scope.afterLoadCustomersImportByXlsClicRdv  = function(customersImportByXls) {
            let customerView;
            let birthDate;
            let existingCustomers = CustomerData.getActiveList();
            let existingCustomersView = [];
            for(let i=0;i<existingCustomers.length ;i++)
                existingCustomersView.push(new CustomerView(existingCustomers[i],CustomerData.getIndexOf(existingCustomers[i]),$scope));

            $scope.dd.view.logs = [];
            $scope.dd.view.errors = [];
            for (let i =0; i<customersImportByXls.length;i++)
            {
                let lineNb = i + 2;
                customerView = new CustomerView(null,-1,$scope);

                customerView.lastName=customersImportByXls[i]["Nom"];
                if ($scope.isBlank(customerView.lastName)) {
                    $scope.dd.view.errors.push({
                        message: gettextCatalog.getString("Ligne " + lineNb + " - Nom manquant (Client non importé)")
                    });
                    continue;
                }
                customerView.firstName = customersImportByXls[i]["Prénom"];
                if ($scope.isBlank(customerView.firstName)) {
                    $scope.dd.view.errors.push({
                        message: gettextCatalog.getString("Ligne " + lineNb + " - Prénom manquant (Client non importé)")
                    });
                    continue;
                }
                customerView.lastName = $scope.trimAndUpperFirst(customerView.lastName);
                customerView.firstName = $scope.trimAndUpperFirst(customerView.firstName);

                birthDate = customersImportByXls[i]["Date de Naissance"];
                if (birthDate !== undefined && birthDate && birthDate.length >= 10) {
                    let dateFormatted = birthDate.substring(6, 10) + "-" + birthDate.substring(3, 5) + "-" + birthDate.substring(0, 2);
                    customerView.birthDate = new Date(dateFormatted);
                }

                let region = PhoneFormat.getLocalCountry();
                customerView.phone=customersImportByXls[i]["Tél. portable"];
                if (customerView.phone) {
                    customerView.phone = $scope.checkPhoneNumberValidity(customerView.phone, true, region);
                    if(customerView.phone == null){
                        $scope.dd.view.errors.push({message: gettextCatalog.getString("Ligne " + lineNb + " - Numéro de mobile incorrect: " + customersImportByXls[i]["Tél. portable"] + " (Client " + customerView.lastName + " " + customerView.firstName + " non importé)")});
                        continue;
                    }
                }

                customerView.landline=customersImportByXls[i]["Tél. fixe"];
                if (customerView.landline) {
                    customerView.landline = $scope.checkPhoneNumberValidity(customerView.landline, false, region);
                    if(customerView.landline == null){
                        $scope.dd.view.errors.push({message:gettextCatalog.getString("Ligne " + lineNb + " - Numéro de fixe incorrect: " + customersImportByXls[i]["Tél. fixe"] + " (Client " + customerView.lastName + " " + customerView.firstName + " non importé)")});
                        continue;
                    }
                }

                customerView.email=customersImportByXls[i]["E-mail"];
                customerView.origin=customersImportByXls[i]["Origine"];
                customerView.address1=customersImportByXls[i]["Adresse"];
                customerView.postCode=customersImportByXls[i]["Code Postal"];
                customerView.city=customersImportByXls[i]["Ville"];
                customerView.comment = customersImportByXls[i]["Commentaire"];

                let foundCustomerView = null;
                for (let j=0;j<existingCustomersView.length && !foundCustomerView;j++){
                    if (existingCustomersView[j].firstName === customerView.firstName && existingCustomersView[j].lastName === customerView.lastName) {
                        foundCustomerView = existingCustomersView[j];
                    }
                }
                if (foundCustomerView)
                {
                    if($scope.dd.view.updateMode)
                    {
                        foundCustomerView.loadDataFrom(customerView);
                        customerView = foundCustomerView;
                        $scope.dd.view.logs.push({message: gettextCatalog.getString("Déjà présent dans la base : " + customerView.lastName + " " + customerView.firstName + " "+customerView.phone + " "+customerView.email + " (l'import mettra le client à jour)")});
                    }
                    else {
                        $scope.dd.view.logs.push({message: gettextCatalog.getString("Déjà présent dans la base : " + customerView.lastName + " " + customerView.firstName + " " + customerView.phone + " " + customerView.email + " (l'import crééra un nouveau client)")});
                    }
                }
                else {
                    //search on import list
                    for (let j = 0; j < $scope.dd.view.customersImportView.length && !foundCustomerView; j++)
                        if ($scope.dd.view.customersImportView[j].firstName === customerView.firstName && $scope.dd.view.customersImportView[j].lastName === customerView.lastName) {
                            foundCustomerView = $scope.dd.view.customersImportView[j];//use second data instead
                        }
                    if (foundCustomerView) {
                        $scope.dd.view.logs.push({message: gettextCatalog.getString("Déjà présent dans l'import  : " + customerView.lastName + " " + customerView.firstName + " " + customerView.phone + " " + customerView.email + " (l'import crééra un nouveau client)")});
                    }
                }

                if(customersImportByXls[i]["Consentement SMS"] != null &&  customersImportByXls[i]["Consentement Emails"] != null && customersImportByXls[i]["Consentement Notif."] != null){
                    customerView.optInOutView = new OptInOutView(null, -1);
                    customerView.optInOutView.isSmsCampaignAllowed = customersImportByXls[i]["Consentement SMS"] === '1' ? true : false;
                    customerView.optInOutView.isEmailCampaignAllowed = customersImportByXls[i]["Consentement Emails"] === '1' ? true : false;
                    customerView.optInOutView.isNotificationCampaignAllowed = customersImportByXls[i]["Consentement Notif."] === '1' ? true : false;
                    customerView.optInOutView.isExternalOptInOut = true;
                    customerView.optInOutView.origin = customersImportByXls[i]["Origine consentement"] != null ? customersImportByXls[i]["Origine consentement"] : '';
                    let dateOptInOut = customersImportByXls[i]["Date de consentement"];
                    if(dateOptInOut != undefined && dateOptInOut.length>=10){
                        let dateFormatted = dateOptInOut;
                        if(dateOptInOut.indexOf("/") !== -1){
                            dateFormatted  =  dateOptInOut.substring(6,10) + "-" + dateOptInOut.substring(3,5) + "-" + dateOptInOut.substring(0,2)
                        }
                        customerView.optInOutView.timeModified = $filter('date')(dateFormatted, 'yyyy-MM-dd');
                    }
                    else{
                        customerView.optInOutView.timeModified = $filter('date')( new Date(), 'yyyy-MM-dd');
                    }
                }
                else{
                    $scope.dd.view.logs.push({message: gettextCatalog.getString("Infos RGPD non importées. Colonnes manquantes ... : " + customerView.lastName + " " + customerView.firstName)});
                    customerView.optInOutView = null;
                }

                if ($scope.dd.view.customersImportView.indexOf(customerView)===-1) {
                    $scope.dd.view.customersImportView.push(customerView);
                }
            }
            console.log($scope.dd.view.customersImportView);
            console.log($scope.dd.view.logs);
            console.log($scope.dd.view.errors);
            $scope.dd.view.customersDisplayView = $scope.dd.view.customersImportView.slice(0,100);
            $scope.dd.view.waitingForLoading = false;
        };

        $scope.afterLoadCustomersImportByCsvArteBeaute  = function(customersImportByCsv)
        {
            var customerView;
            var existingCustomers = CustomerData.getActiveList();
            var existingCustomersView = [];
            for(var i=0;i<existingCustomers.length ;i++)
                existingCustomersView.push(new CustomerView(existingCustomers[i],CustomerData.getIndexOf(existingCustomers[i]),$scope));

            for (var i =1; i<customersImportByCsv.length;i++)
            {
                if (customersImportByCsv[i][4] && customersImportByCsv[i][4]!='')
                {
                    var capitalized;
                    customerView = new CustomerView(null,-1,$scope);
                    customerView.gender="M";
                    if (customersImportByCsv[i][3]!='Mr.');
                    customerView.gender="W";
                    customerView.lastName=customersImportByCsv[i][4];
                    if (customerView.lastName)
                    {
                        capitalized  = customerView.lastName.toLowerCase();
                        customerView.lastName = capitalized.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
                    }

                    customerView.firstName=customersImportByCsv[i][5];
                    if (customerView.firstName)
                    {
                        capitalized  = customerView.firstName.toLowerCase();
                        customerView.firstName = capitalized.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
                    }
                    customerView.address1=customersImportByCsv[i][6];
                    customerView.postCode=customersImportByCsv[i][7];
                    customerView.city=customersImportByCsv[i][8];

                    customerView.phone=customersImportByCsv[i][9];
                    if (customerView.phone)
                    {
                        customerView.phone =  Format.formatNumber(customerView.phone);
                    }
                    customerView.email=customersImportByCsv[i][10];

                    var foundSame = false;
                    for (var j=0;j<existingCustomersView.length && !foundSame;j++)
                        if (existingCustomersView[j].firstName==customerView.firstName && existingCustomersView[j].lastName==customerView.lastName)
                            foundSame = true;

                    for (var j=0;j<$scope.dd.view.customersImportView.length && !foundSame;j++)
                        if ($scope.dd.view.customersImportView[j].firstName==customerView.firstName && $scope.dd.view.customersImportView[j].lastName==customerView.lastName)
                        {
                            foundSame = true;//use second data instead
                            $scope.dd.view.customersImportView[j].loadDataFrom(customerView);
                        }

                    if (!foundSame)
                        $scope.dd.view.customersImportView.push(customerView);
                    else
                        console.log("Already found : " + customerView.lastName + " " + customerView.firstName + " "+customerView.phone + " "+customerView.email + " ");
                    //customerView.updateModel();
                }
            }
        };
        $scope.afterLoadProductsImport  = function(productsImportByCsv)
        {
            if (!$scope.dd.view.productCategoryRootView)
                $scope.dd.view.productCategoryRootView = new ProductCategoryView(ProductCategoryData.categoryRoot,ProductCategoryData.getIndexOf(ProductCategoryData.categoryRoot),null,$scope);// categoryRoot index  = 0
            var categoryView,subCategoryView;
            var categorieLabel,subCategorieLabel,supplierLabel,quantity;
            for (var i =0; i<productsImportByCsv.length;i++) {
                subCategoryView = null;
                categorieLabel = productsImportByCsv[i]["Catégorie"];
                subCategorieLabel = productsImportByCsv[i]["Sous-Catégorie"];
                if (categorieLabel && categorieLabel != '') {
                    categoryView = $scope.dd.view.productCategoryRootView.getCategoryViewByLabel(categorieLabel);
                    if (!categoryView) {
                        categoryView = new ProductCategoryView(null, -1, $scope.dd.view.productCategoryRootView, $scope);
                        categoryView.label = categorieLabel;
                        $scope.dd.view.productCategoryRootView.addCategoryView(categoryView);
                    }
                    if (subCategorieLabel && subCategorieLabel != '') {
                        subCategoryView = categoryView.getCategoryViewByLabel(subCategorieLabel);
                        if (!subCategoryView) {
                            subCategoryView = new ProductCategoryView(null, -1, categoryView, $scope);
                            subCategoryView.label = subCategorieLabel;
                            categoryView.addCategoryView(subCategoryView);
                        }
                    }
                    var newProductView = new ProductView(null, -1, subCategoryView ? subCategoryView : categoryView, $scope);
                    newProductView.label = productsImportByCsv[i]["Libellé produit"];
                    newProductView.reference = productsImportByCsv[i]["Référence"];
                    //Pa HT	Prix Vente TTC	Stock

                    newProductView.buyingPriceInput = productsImportByCsv[i]["Prix d'achat (HT)"];
                    newProductView.onBuyingPriceInputChange();
                    newProductView.priceInput = productsImportByCsv[i]["Prix de vente TTC"];
                    newProductView.onPriceInputChange();

                    var vatInput = productsImportByCsv[i]["TVA"];
                    var vatView = null;
                    if (vatInput) {
                        if (vatInput != null && typeof vatInput === 'string') {
                            var vatStr = vatInput.replace("%", "").replace(",", ".").replace(" ", "");
                            var vat = parseFloat(vatStr);
                            vatView = $scope.getVatViewByTax(vat);
                            if (vatView)
                                newProductView.vatView = vatView;
                        }
                    }

                    quantity = parseInt(productsImportByCsv[i]["Stock"]);
                    if (!isNaN(quantity))
                        newProductView.quantity = quantity;
                    newProductView.code = productsImportByCsv[i]["Code barre"];
                    if (newProductView.code && newProductView.code.indexOf('\'') == 0)//remove ' if first
                        newProductView.code = newProductView.code.substr(1);
                    newProductView.reference = productsImportByCsv[i]["Référence"];
                    newProductView.description = productsImportByCsv[i]["Description"];
                    supplierLabel = productsImportByCsv[i]["Fournisseur"];
                    var foundProductView = null;

                    //var containerCategory = subCategoryView ? subCategoryView : categoryView;

                    if ($scope.dd.view.updateMode) {

                        if(newProductView.reference != null && newProductView.reference != ""){

                            var foundProduct = ProductData.getByRef(newProductView.reference);//containerCategory.getProductViewByReference(newProductView.reference);
                            if(foundProduct != null){
                                foundProductView = $scope.dd.view.productCategoryRootView.getProductView(foundProduct);
                            }
                        }
                        if (foundProductView != null) {
                            if(isNaN(quantity))
                                newProductView.quantity = foundProductView.quantity;
                            if(!vatInput) {
                                vatView = $scope.getVatViewByTax(foundProductView.vatView.tax);
                            }
                            if(foundProductView.image != null){
                                newProductView.setImage(foundProductView.image);
                            }
                            else if(foundProductView.companyImage != null){
                                newProductView.setCompanyImage(foundProductView.companyImage);
                            }
                            if(foundProductView.parentCategoryView != null){
                                newProductView.parentCategoryView = foundProductView.parentCategoryView;

                            }
                            foundProductView.loadDataFrom(newProductView);

                            newProductView = foundProductView;

                            if (supplierLabel && supplierLabel != ''){
                                newProductView.supplierView = $scope.getSupplierViewByLabel(supplierLabel);
                                newProductView.supplierInputLabel = supplierLabel;
                            }

                            if(vatView && vatView.tax != foundProductView.vatView.tax){
                                newProductView.vatView = vatView;
                                //newProductView.getModel().vat = vatView.getModel();
                                newProductView.updateTax();
                            }
                            $scope.dd.view.logs.push({message: "Already found in data : " + newProductView.reference + " (import will update product)"});
                        }
                        else {
                            if (supplierLabel && supplierLabel != ''){
                                newProductView.supplierView = $scope.getSupplierViewByLabel(supplierLabel);
                                newProductView.supplierInputLabel = supplierLabel;
                            }
                            if (subCategoryView)
                                subCategoryView.addProductView(newProductView);
                            else
                                categoryView.addProductView(newProductView);
                            $scope.dd.view.logs.push({message: "No datas found : " + newProductView.reference + " (import will create product)"});
                        }
                    }
                    else {
                        if (subCategoryView)
                            subCategoryView.addProductView(newProductView);
                        else
                            categoryView.addProductView(newProductView);
                        $scope.dd.view.logs.push({message: "No datas found : " + newProductView.reference + " (import will create product)"});

                    }
                }
            }

        };

        $scope.loadMarketplaceDataIfNeeded = function () {
            if (!$scope.dd.marketplaceData.loaded) {
                return MarketplaceSrv.getMarketplaceData().then(
                    data => {
                        if (data && data.marketplaceCategories) {
                            $scope.dd.marketplaceData.marketplaceCategories = data.marketplaceCategories;
                            $scope.dd.marketplaceData.loaded = true;
                        }
                    },
                    () => {
                        $scope.dd.marketplaceData.loaded = false;
                    });
            }
        };

        $scope.computeMarketplaceCategory = function (marketPlaceCategoryLabel) {
            let marketplaceCategories = $scope.dd.marketplaceData.marketplaceCategories;
            if (marketplaceCategories) {
                for (let marketplaceCategory of marketplaceCategories) {
                    if (marketplaceCategory.label && marketplaceCategory.label.localeCompare(marketPlaceCategoryLabel, undefined, {sensitivity: 'base'}) === 0) {
                        return marketplaceCategory;
                    }
                }
            }
            return null;
        };

        $scope.computeMarketplaceSubCategory = function (marketplaceSubCategories, marketPlaceSubCategoryLabel) {
            if (marketplaceSubCategories) {
                for (let marketplaceSubCategory of marketplaceSubCategories) {
                    if (marketplaceSubCategory && marketplaceSubCategory.label && marketplaceSubCategory.label.localeCompare(marketPlaceSubCategoryLabel, undefined, {sensitivity: 'base'}) === 0) {
                        return marketplaceSubCategory;
                    }
                }
            }
            return null;
        };

        $scope.computeMarketplaceVariant = function (marketplaceVariants, marketPlaceVariantLabel) {
            if (marketplaceVariants) {
                for (let marketplaceVariant of marketplaceVariants) {
                    if (marketplaceVariant && marketplaceVariant.label && marketplaceVariant.label.localeCompare(marketPlaceVariantLabel, undefined, {sensitivity: 'base'}) === 0) {
                        return marketplaceVariant;
                    }
                }
            }
            return null;
        };

        $scope.afterLoadServicesImport  = function(servicesImportByCsv) {
            $scope.dd.view.serviceSaveComplete = false;
            if (!$scope.dd.view.serviceCategoryRootView)
                $scope.dd.view.serviceCategoryRootView = new CategoryView(CategoryData.categoryRoot,CategoryData.getIndexOf(CategoryData.categoryRoot),null,$scope);// categoryRoot index  = 0
            let categoryView, subCategoryView;
            let categorieLabel, subCategorieLabel, duration;
            $scope.dd.activationByPartnerLabel = {};
            for (let i = 0; i < $scope.dd.view.partnerActivationSettings.length; i++) {
                $scope.dd.activationByPartnerLabel[$scope.dd.view.partnerActivationSettings[i].role] = $scope.dd.view.partnerActivationSettings[i].activateOnImport;
            }
            $scope.dd.view.errors = [];
            for (var i =0; i<servicesImportByCsv.length;i++)
            {
                subCategoryView = null;
                categorieLabel = servicesImportByCsv[i]["Catégorie"];
                subCategorieLabel = servicesImportByCsv[i]["Sous-Catégorie"];
                let lineNb = i + 2;
                if (categorieLabel && categorieLabel !== '') {
                    categorieLabel = categorieLabel.trim();
                    categoryView = $scope.dd.view.serviceCategoryRootView.getCategoryViewByLabel(categorieLabel);
                    if (!categoryView) {
                        categoryView = new CategoryView(null, -1, $scope.dd.view.serviceCategoryRootView, $scope);
                        categoryView.label = categorieLabel;
                        $scope.dd.view.serviceCategoryRootView.addCategoryView(categoryView);
                    }
                    if (subCategorieLabel && subCategorieLabel !== '') {
                        subCategorieLabel = subCategorieLabel.trim();
                        subCategoryView = $scope.dd.view.serviceCategoryRootView.getCategoryViewByLabel(subCategorieLabel);
                        if (!subCategoryView) {
                            subCategoryView = new CategoryView(null, -1, categoryView, $scope);
                            subCategoryView.label = subCategorieLabel;
                            categoryView.addCategoryView(subCategoryView);
                            categoryView.impactedByImport = true;
                        }
                    }
                    var newServiceView = new ServiceView(null, -1,subCategoryView  ? subCategoryView : categoryView, $scope);
                    newServiceView.label = servicesImportByCsv[i]["Prestation"];
                    if (newServiceView.label) {
                        newServiceView.label = newServiceView.label.trim();
                        newServiceView.labelShort = newServiceView.label;

                        let errorInMarketplaceData = $scope.importMarketplaceDataIfNeeded(servicesImportByCsv[i], categoryView, subCategoryView, newServiceView, lineNb);

                        if (!errorInMarketplaceData) {
                            newServiceView.impactedByImport = true;
                            //Pa HT	Prix Vente TTC	Stock
                            newServiceView.price = servicesImportByCsv[i]["Prix"];
                            newServiceView.onGlobalPriceInputChange();
                            duration = parseInt(servicesImportByCsv[i]["Durée"].replace(" min", "").replace(" mn", ""));
                            if (duration !== "NaN" && duration !== "")
                                newServiceView.duration = duration;
                            if (subCategoryView) {
                                subCategoryView.addServiceView(newServiceView);
                                subCategoryView.impactedByImport = true;
                                $scope.dd.view.serviceImportReady = true;
                            } else {
                                categoryView.addServiceView(newServiceView);
                                categoryView.impactedByImport = true;
                                $scope.dd.view.serviceImportReady = true;
                            }
                        }
                    } else {
                        $scope.dd.view.errors.push({message: gettextCatalog.getString("Ligne " + lineNb + " - Service manquant ou incorrect (Prestation non importée)")});
                    }
                } else {
                    $scope.dd.view.errors.push({message: gettextCatalog.getString("Ligne " + lineNb + " - Catégorie manquante ou incorrecte (Prestation non importée)")});
                }
            }
            $scope.dd.view.waitingForLoading = false;
        };

        $scope.importMarketplaceDataIfNeeded = function(importedServiceLine, categoryView, subCategoryView, newServiceView, lineNb) {
            let errorInMarketplaceData = false;
            if ($scope.dd.activationByPartnerLabel[BasicAuthRole.LE_CISEAU_ROLE.role]) {
                let categoryMarketPlaceLabel = importedServiceLine["Catégorie " + $scope.ad.brand.marketplace.url.shortWebsite];
                let subCategoryMarketPlaceLabel = importedServiceLine["Sous-Catégorie " + $scope.ad.brand.marketplace.url.shortWebsite];
                let variantMarketPlaceLabel = importedServiceLine["Variante " + $scope.ad.brand.marketplace.url.shortWebsite];

                let marketplaceCategoryId, marketplaceSubCategoryId, marketplaceVariantId;

                categoryMarketPlaceLabel = categoryMarketPlaceLabel ? categoryMarketPlaceLabel.trim() : null;
                subCategoryMarketPlaceLabel = subCategoryMarketPlaceLabel ? subCategoryMarketPlaceLabel.trim() : null;
                variantMarketPlaceLabel = variantMarketPlaceLabel ? variantMarketPlaceLabel.trim() : null;

                let marketplaceCategory = $scope.computeMarketplaceCategory(categoryMarketPlaceLabel);
                if (marketplaceCategory) {
                    marketplaceCategoryId = marketplaceCategory.id;

                    let marketplaceSubCategory = $scope.computeMarketplaceSubCategory(marketplaceCategory.subCategories, subCategoryMarketPlaceLabel);
                    if (marketplaceSubCategory) {
                        marketplaceSubCategoryId = marketplaceSubCategory.id;
                    } else {
                        $scope.dd.view.errors.push({message: gettextCatalog.getString("Ligne " + lineNb + " - Sous-Catégorie " + $scope.ad.brand.marketplace.url.shortWebsite + " manquante ou incorrecte (Prestation non importée)")});
                        errorInMarketplaceData = true;
                    }

                    if (!variantMarketPlaceLabel || marketplaceCategory.variants.length === 0) {
                        marketplaceVariantId = null;
                    } else {
                        let marketplaceVariant = $scope.computeMarketplaceVariant(marketplaceCategory.variants, variantMarketPlaceLabel);
                        if (marketplaceVariant) {
                            newServiceView.label = marketplaceVariant.id ? newServiceView.labelShort + " - " + marketplaceVariant.label : newServiceView.labelShort;
                            marketplaceVariantId = marketplaceVariant.id;
                        } else {
                            $scope.dd.view.errors.push({message: gettextCatalog.getString("Ligne " + lineNb + " - Variante " + $scope.ad.brand.marketplace.url.shortWebsite + " manquante ou incorrecte (Prestation non importée)")});
                            errorInMarketplaceData = true;
                        }
                    }
                } else {
                    $scope.dd.view.errors.push({message: gettextCatalog.getString("Ligne " + lineNb + " - Catégorie " + $scope.ad.brand.marketplace.url.shortWebsite + " manquante ou incorrecte (Prestation non importée)")});
                    errorInMarketplaceData = true;
                }

                if (!errorInMarketplaceData) {
                    let pathService = $scope.computePathService(categoryView, subCategoryView, newServiceView);
                    $scope.dd.marketplaceData.services[pathService] = {
                        marketplaceCategoryId: marketplaceCategoryId,
                        marketplaceSubCategoryId: marketplaceSubCategoryId,
                        marketplaceVariantId: marketplaceVariantId
                    };
                }
            }
            return errorInMarketplaceData;
        };

        $scope.computePathService = function (categoryView, subCategoryView, serviceView) {
            let pathService = "/";
            if (categoryView && categoryView.label !== "Racine") {
                pathService = pathService + categoryView.label + "/";
            }
            if (subCategoryView) {
                pathService = pathService + subCategoryView.label + "/";
            }
            pathService = pathService + serviceView.label;
            return pathService;
        };

        $scope.afterLoadProductsImportByCsvArteBeaute  = function(productsImportByCsv)
        {

            if (!$scope.dd.view.productCategoryRootView)
                $scope.dd.view.productCategoryRootView = new ProductCategoryView(ProductCategoryData.categoryRoot,ProductCategoryData.getIndexOf(ProductCategoryData.categoryRoot),null,$scope);// categoryRoot index  = 0
            var categoryView;
            for (var i =1; i<productsImportByCsv.length;i++)
            {
                if (productsImportByCsv[i][0] && productsImportByCsv[i][0]!='')
                {
                    categoryView = $scope.dd.view.productCategoryRootView.getCategoryViewByLabel(productsImportByCsv[i][0]);
                    if (!categoryView)
                    {
                        categoryView = new ProductCategoryView(null,-1,$scope.dd.view.productCategoryRootView,$scope);
                        categoryView.label = productsImportByCsv[i][0];
                        $scope.dd.view.productCategoryRootView.addCategoryView(categoryView);
                    }
                    var newProductView =   new ProductView(null,-1,categoryView,$scope);
                    newProductView.label = productsImportByCsv[i][2];
                    //Pa HT	Prix Vente TTC	Stock

                    newProductView.buyingPriceInput = productsImportByCsv[i][3];
                    newProductView.priceInput = productsImportByCsv[i][4];
                    newProductView.quantity = parseInt(productsImportByCsv[i][5]);
                    categoryView.addServiceView(newProductView);

                }
            }
        }
        $scope.afterLoadCustomersImportByCsvShortcuts  = function(customersImportByCsv)
        {
            var customerView;
            console.log("afterLoadCustomersImportByCsvShortcuts");
            console.log(customersImportByCsv);
            var existingCustomers = CustomerData.getActiveList();
            var existingCustomersView = [];
            for(var i=0;i<existingCustomers.length ;i++)
                existingCustomersView.push(new CustomerView(existingCustomers[i],CustomerData.getIndexOf(existingCustomers[i]),$scope));

            for (var i =1; i<customersImportByCsv.length;i++)
            {
                if (customersImportByCsv[i][0] && customersImportByCsv[i][0]!='')
                {
                    var capitalized;
                    customerView = new CustomerView(null,-1,$scope);
                    customerView.shortcutsId =  customersImportByCsv[i][0];
                    customerView.lastName=customersImportByCsv[i][1];
                    if (customerView.lastName)
                    {
                        capitalized  = customerView.lastName.toLowerCase();
                        customerView.lastName = capitalized.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
                    }

                    customerView.firstName=customersImportByCsv[i][2];
                    if (customerView.firstName)
                    {
                        capitalized  = customerView.firstName.toLowerCase();
                        customerView.firstName = capitalized.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
                    }
                    customerView.address1=customersImportByCsv[i][3];
                    customerView.address2=customersImportByCsv[i][4];
                    customerView.city=customersImportByCsv[i][5];
                    customerView.postCode=customersImportByCsv[i][6];
                    customerView.landline=customersImportByCsv[i][7];
                    if (customerView.landline)
                    {
                        customerView.landline =  Format.formatNumber(customerView.landline);
                    }
                    customerView.phone=customersImportByCsv[i][8];
                    if (customerView.phone)
                    {
                        customerView.phone =  Format.formatNumber(customerView.phone);
                    }
                    customerView.email=customersImportByCsv[i][9];
                    if (customersImportByCsv[i][10]=="1")//Man
                        customerView.gender="M";
                    else
                        customerView.gender="W";
                    var foundSame = false;
                    for (var j=0;j<existingCustomersView.length && !foundSame;j++)
                        if ((existingCustomersView[j].phone && existingCustomersView[j].phone!="" &&
                                customerView.phone && customerView.phone!="" && existingCustomersView[j].phone==customerView.phone) &&
                            (//no email or sms but same lastname/firstname
                                (!existingCustomersView[j].email || existingCustomersView[j].email=="") &&
                                (!customerView.phone || customerView.phone=="") &&
                                existingCustomersView[j].firstName==customerView.firstName && existingCustomersView[j].lastName==customerView.lastName
                            ))
                            foundSame = true;

                    if (!foundSame)
                        $scope.dd.view.customersImportView.push(customerView);
                    else
                        console.log("Already found : " + customerView.lastName + " " + customerView.firstName + " "+customerView.phone + " "+customerView.email + " ");
                    //customerView.updateModel();
                }
            }
        }
        $scope.afterLoadCustomersImportByCsvShortcutsComment  = function(customersImportByCsv)
        {
            console.log("afterLoadCustomersImportByCsvShortcutsComment");
            console.log(customersImportByCsv);
            var found = false;
            var id = null;
            var idInt = null;
            var commentPart;
            var newLine = true;
            for (var i =1; i<customersImportByCsv.length;i++)
            {
                commentPart = null;
                if (customersImportByCsv[i][0] && customersImportByCsv[i][0]!='')
                {

                    idInt = parseInt(customersImportByCsv[i][0]);
                    if (idInt === NaN) {
                        commentPart= customersImportByCsv[i][0];
                        newLine = false;
                    }
                    else
                    {

                        id = customersImportByCsv[i][0];
                        commentPart= customersImportByCsv[i][1];
                        newLine = true;
                    }
                }
                if (id && commentPart)
                {
                    found = false;
                    for (var j=0;j<$scope.dd.view.customersImportView.length && !found;j++)
                        if (id==$scope.dd.view.customersImportView[j].shortcutsId)
                        {
                            found = true;
                            if (!newLine && $scope.dd.view.customersImportView[j].comment)
                                $scope.dd.view.customersImportView[j].comment = $scope.dd.view.customersImportView[j].comment + " " + commentPart;
                            else
                                $scope.dd.view.customersImportView[j].comment = commentPart;
                        }
                }
            }
        }

        $scope.checkBeforeSaveImportedCustomersView = function()
        {
            if($scope.dd.view.errors.length != 0) {
                let msgQuestion = gettextCatalog.getString("Des erreurs ont été trouvées pendant l'import, êtes-vous sûr de vouloir sauvegarder");
                let opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/generalConfirm.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function () {
                            let tableModel = [];
                            tableModel["question"] = msgQuestion + " ?";
                            return tableModel;
                        }
                    }
                };

                let d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result) {
                        $scope.saveImportedCustomersView();
                    }
                });
            }
            else{
                $scope.saveImportedCustomersView();
            }
        };
        $scope.saveImportedCustomersView  = function()
        {
            console.log("importCustomersView");
            console.log($scope.dd.view.customersImportView);
            $scope.dd.view.saving = true;
            $scope.dd.view.customersSavedView = [];
            for (let i = 0; i < $scope.dd.view.customersImportView.length; i++) {
                $scope.saveImportedCustomerView($scope.dd.view.customersImportView[i]);
            }
        };
        $scope.saveImportedCustomerView  = function(customerView)
        {
            customerView.updateModel(true,
                function(){
                    if(customerView.optInOutView != null && customerView.optInOutView.timeModified != null && customerView.getModel() != null){
                        customerView.optInOutView.updateModel(null, null, customerView.getModel().getId());
                    }
                    $scope.dd.view.customersSavedView.push(customerView);
                    if ($scope.dd.view.customersSavedView.length==$scope.dd.view.customersImportView.length)
                    {
                        $scope.dd.view.customersImportView = [];
                        $scope.dd.view.customersDisplayView = [];
                        $scope.dd.view.saving = false;
                    }
                }
            );
        }
        $scope.saveImportedProductsView  = function()
        {
            var supplierView;
            console.log("importSuppliersView");
            console.log($scope.dd.view.suppliersImportView);
            $scope.dd.view.suppliersSavedView = [];
            if ($scope.dd.view.suppliersImportView.length>0)
                for (var i =0; i<$scope.dd.view.suppliersImportView.length ;i++)
                    $scope.saveImportedSupplierView($scope.dd.view.suppliersImportView[i]);
            else
                $scope.saveImportedProductsTreeView();

        }
        $scope.saveImportedSupplierView  = function(supplierView)
        {
            console.log("save supplierView " + supplierView.label);
            supplierView.updateModel(true,
                function(){
                    $scope.dd.view.suppliersSavedView.push(supplierView);
                    if ($scope.dd.view.suppliersSavedView.length==$scope.dd.view.suppliersImportView.length)
                    {
                        $scope.saveImportedProductsTreeView();
                    }
                }
            );
        };
        $scope.saveImportedProductsTreeView  = function() {

            for (var j=0;j< $scope.dd.view.productCategoryRootView.categoriesView.length;j++)
                $scope.dd.view.productCategoryRootView.categoriesView[j].updateModelTree();
        };

        $scope.saveImportedServicesTreeView  = function() {
            $scope.dd.view.saving = true;

            let globalImportData = {
                categoryViewsToUpdate: [],
                serviceCount: 0
            };
            for (let j = 0; j < $scope.dd.view.serviceCategoryRootView.categoriesView.length; j++) {
                let categoryTreeImportData = $scope.dd.view.serviceCategoryRootView.categoriesView[j].computeViewsImpactedByImportAndCountServices();
                globalImportData.categoryViewsToUpdate = globalImportData.categoryViewsToUpdate.concat(categoryTreeImportData.categoryViewsToUpdate);
                globalImportData.serviceCount = globalImportData.serviceCount + categoryTreeImportData.serviceCount;
            }
            if (globalImportData.categoryViewsToUpdate.length > 0 && globalImportData.serviceCount < Constants.MAX_SERVICES_FOR_COMPANY) {
                $scope.saveCategoryViewsToUpdate(globalImportData.categoryViewsToUpdate, 0, $scope.dd.activationByPartnerLabel);
            } else {
                $scope.dd.view.saving = false;
                $scope.dd.view.tooManyServicesImported = true;
            }
        };

        $scope.saveCategoryViewsToUpdate = function(categoryViewsToUpdate, index, activationByPartnerLabel) {
            let categoryViewToUpdate = categoryViewsToUpdate[index];
            categoryViewToUpdate.updateModel(
                function() {
                    categoryViewToUpdate.impactedByImport = false;
                    if (categoryViewToUpdate.servicesView && categoryViewToUpdate.servicesView.length > 0) {
                        $scope.saveServiceViewsToUpdate(categoryViewsToUpdate, index, 0, activationByPartnerLabel);
                    } else {
                        $scope.saveNextCategoryToImportOrFinish(categoryViewsToUpdate, index, activationByPartnerLabel);
                    }
                }, function () {
                    $scope.dd.view.saving = false;
                });
        };

        $scope.saveNextCategoryToImportOrFinish = function(categoryViewsToUpdate, index, activationByPartnerLabel) {
            if (index !== categoryViewsToUpdate.length - 1) {
                $scope.saveCategoryViewsToUpdate(categoryViewsToUpdate, index + 1, activationByPartnerLabel);
            } else {
                $scope.dd.view.serviceImportReady = false;
                $scope.dd.view.saving = false;
                $scope.dd.view.serviceSaveComplete = true;
            }
        };

        $scope.saveServiceViewsToUpdate = function(categoryViewsToUpdate, indexCategories, indexServices, activationByPartnerLabel) {
            let categoryViewToUpdate = categoryViewsToUpdate[indexCategories];
            let serviceViewToUpdate = categoryViewToUpdate.servicesView[indexServices];
            if (serviceViewToUpdate.impactedByImport) {
                serviceViewToUpdate.impactedByImport = false;
                let settingsByPartnerLabel = {};
                let pathService = $scope.computePathService(categoryViewToUpdate.parentCategoryView, categoryViewToUpdate, serviceViewToUpdate);
                settingsByPartnerLabel[BasicAuthRole.LE_CISEAU_ROLE.role] = $scope.dd.marketplaceData.services[pathService];
                serviceViewToUpdate.updateModelAndCreateWithPartnerServiceSettings(activationByPartnerLabel, settingsByPartnerLabel,
                        function() {
                            $scope.saveNextServiceToImportOrFinish(categoryViewsToUpdate, indexCategories, serviceViewToUpdate, indexServices, activationByPartnerLabel);
                        },
                        function () {
                            $scope.dd.view.saving = false;
                        });
            } else {
                $scope.saveNextServiceToImportOrFinish(categoryViewsToUpdate, indexCategories, serviceViewToUpdate, indexServices, activationByPartnerLabel)
            }
        };

        $scope.saveNextServiceToImportOrFinish = function(categoryViewsToUpdate, indexCategories, serviceViewToUpdate, indexServices, activationByPartnerLabel) {
            serviceViewToUpdate.impactedByImport = false;
            if (indexServices !== categoryViewsToUpdate[indexCategories].servicesView.length - 1) {
                $scope.saveServiceViewsToUpdate(categoryViewsToUpdate, indexCategories, indexServices + 1, activationByPartnerLabel);
            } else {
                $scope.saveNextCategoryToImportOrFinish(categoryViewsToUpdate, indexCategories, activationByPartnerLabel);
            }
        };

        $scope.resetServiceTreeImport = function() {
            $scope.dd.view.waitingForLoading = false;
            $scope.dd.view.serviceImportReady = false;
            $scope.dd.view.saving = false;
            $scope.dd.view.serviceSaveComplete = false;
            $scope.dd.view.tooManyServicesImported = false;
            $scope.dd.view.serviceCategoryRootView = new CategoryView(CategoryData.categoryRoot,CategoryData.getIndexOf(CategoryData.categoryRoot),null,$scope);// categoryRoot index  = 0
            $scope.dd.view.serviceCategoryRootView.label = "Racine";
            $scope.dd.view.currentServiceCategoryView = $scope.dd.view.serviceCategoryRootView;
        };

        $scope.afterLoadBookingsImportByXlsClicRdv  = function(bookingsImportByXls)
        {
            var cCustomerView;
            var existingCustomers = CustomerData.getActiveList();
            var existingCustomersView = [];
            for(var i=0;i<existingCustomers.length ;i++)
                existingCustomersView.push(new CustomerView(existingCustomers[i],CustomerData.getIndexOf(existingCustomers[i]),$scope));
            var existingHrs = HumanResourceData.getActiveList();
            var existingPrs = PhysicalResourceData.getActiveList();
            $scope.dd.view.logs = [];
            for (var i =0; i<bookingsImportByXls.length;i++)
            {
                //if (bookingsImportByXls[i][0] && bookingsImportByXls[i][0]!='')
                {
                    var capitalized;
                    cCustomerView = new CustomerView(null,-1,$scope);
                    cCustomerView.lastName=bookingsImportByXls[i]["Nom"];
                    if (cCustomerView.lastName)
                    {
                        capitalized  = cCustomerView.lastName.toLowerCase();
                        cCustomerView.lastName = capitalized.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
                    }

                    cCustomerView.firstName=bookingsImportByXls[i]["Prénom"];
                    if (cCustomerView.firstName)
                    {
                        capitalized  = cCustomerView.firstName.toLowerCase();
                        cCustomerView.firstName = capitalized.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
                    }
                    cCustomerView.email=bookingsImportByXls[i]["E-mail"];
                    cCustomerView.phone=bookingsImportByXls[i]["Tél. portable"];
                    if (cCustomerView.phone)
                    {
                        cCustomerView.phone = Format.formatNumber(cCustomerView.phone);
                    }

                    var existingCustomerView = null;
                    //try to find with  firstName && lastName (email || phone)
                    if ((cCustomerView.email && cCustomerView.email!='') || (cCustomerView.phone && cCustomerView.phone!=''))
                        for (var j=0;j<existingCustomersView.length && !existingCustomerView;j++)
                        {
                            if (existingCustomersView[j].firstName==cCustomerView.firstName && existingCustomersView[j].lastName==cCustomerView.lastName  &&
                                ((cCustomerView.email && cCustomerView.email!='' && existingCustomersView[j].email==cCustomerView.email) ||
                                    (cCustomerView.phone && cCustomerView.phone!='' && existingCustomersView[j].phone==cCustomerView.phone)))
                            {
                                existingCustomerView = existingCustomersView[j];
                                cCustomerView.cIndex = j;
                            }
                        }
                    if (!existingCustomerView)//try with only firstName && lastName
                        for (var j=0;j<existingCustomersView.length && !existingCustomerView;j++)
                        {
                            if (existingCustomersView[j].firstName==cCustomerView.firstName && existingCustomersView[j].lastName==cCustomerView.lastName)
                            {
                                existingCustomerView = existingCustomersView[j];
                                cCustomerView.cIndex = j;
                            }
                        }
                    if (existingCustomerView)
                    {
                        var hr = null;
                        var pr = null;
                        var prNumber =0;
                        var prLabel;
                        for (var k=0;k<existingHrs.length && !hr;k++)
                        {
                            if (existingHrs[k].label.replace(/\s/g, '')==bookingsImportByXls[i]["Agenda"].replace(/\s/g, ''))
                                hr =existingHrs[k];
                        }
                        for (var k=0;k<existingPrs.length && !pr;k++)
                        {
                            for (prNumber=1;prNumber<=existingPrs[k].number&& !pr;prNumber++)
                            {
                                prLabel = existingPrs[k].label;
                                if (existingPrs[k].number>1)
                                    prLabel = prLabel + " " +  prNumber;
                                if (prLabel.replace(/\s/g, '')==bookingsImportByXls[i]["Agenda"].replace(/\s/g, ''))
                                    pr =existingPrs[k];

                            }
                        }
                        if (hr || pr)
                        {
                            var service = CategoryData.categoryRoot.getServiceByLabel(bookingsImportByXls[i]["Rdv proposé"].replace(/\s+$/, '').toLowerCase());//remove last space
                            if (service)
                            {
                                //getDay
                                var year = bookingsImportByXls[i]["Date et heure de début"].substr(6,4);
                                var month = bookingsImportByXls[i]["Date et heure de début"].substr(3,2);
                                var dayOfM = bookingsImportByXls[i]["Date et heure de début"].substr(0,2);

                                if (year.indexOf("-")!=-1)
                                {
                                    year = bookingsImportByXls[i]["Date et heure de début"].substr(0,4);
                                    month = bookingsImportByXls[i]["Date et heure de début"].substr(5,2);
                                    dayOfM = bookingsImportByXls[i]["Date et heure de début"].substr(8,2);
                                }
                                var startHour =  bookingsImportByXls[i]["Date et heure de début"].substr(11,2);
                                var startMinute =  bookingsImportByXls[i]["Date et heure de début"].substr(14,2);
                                var endHour =  bookingsImportByXls[i]["Date et heure de fin"].substr(11,2);
                                var endMinute =  bookingsImportByXls[i]["Date et heure de fin"].substr(14,2);
                                var dayId = year+month+dayOfM;
                                if (dayId.length==8)
                                {
                                    var day = DayData.getById(parseInt(dayId))
                                    if (!day)
                                    {
                                        day = new Day();
                                        day.id = parseInt(dayId);
                                        DayData.insert(day);
                                    }
                                    var dayR = null;
                                    if (hr)
                                    {
                                        dayR = day.getDayHrByHrId(hr.id);
                                        if (!dayR)
                                            dayR = day.createAndAddDayHr(hr.id);
                                        dayR.humanResourceLabel = hr.label;//TODO OPTIMIZE;
                                    }
                                    if (pr)
                                    {
                                        dayR = day.getDayPrByPrId(pr.id,prNumber);
                                        if (!dayR)
                                            dayR = day.createAndAddDayPr(pr.id,prNumber);
                                        dayR.physicalResourceLabel = pr.label;
                                        if (pr.number>1)
                                            dayR.physicalResourceLabel = dayR.physicalResourceLabel + " " +  prNumber;
                                    }
                                    var booking = day.getBookingByCustomerId(existingCustomerView.getModel().id);
                                    if (!booking)
                                    {
                                        booking = new Booking();

                                        booking.status = "planned";
                                        booking.customer = existingCustomerView.getModel();
                                        day.addBooking(booking);
                                        if (bookingsImportByXls[i]["Pris par internet"]=="1")
                                            booking.isCreatedByCustomer = true;
                                        if (bookingsImportByXls[i]["Venu / pas venu"]=="Pas Venu")
                                            booking.status = "notCame";
                                        if (bookingsImportByXls[i]["Venu / pas venu"]=="Venu")
                                            booking.status = "came";
                                        $scope.dd.view.bookingsImportView.push(booking);
                                    }
                                    var bookingService = new BookingService();
                                    bookingService.service = service;
                                    bookingService.price = parseInt(bookingsImportByXls[i]["Prix"]);
                                    bookingService.label = service.label;

                                    bookingService.period = new Period();
                                    bookingService.period.setStartHour(parseInt(startHour));
                                    bookingService.period.setStartMinute(parseInt(startMinute));
                                    bookingService.period.setEndHour(parseInt(endHour));
                                    bookingService.period.setEndMinute(parseInt(endMinute));
                                    dayR.addActivity(bookingService);
                                    booking.addBookingService(bookingService);
                                    if (bookingsImportByXls[i]["Commentaires"]!="" && bookingsImportByXls[i]["Commentaires"]!=booking.comment)
                                        if (booking.comment)
                                            booking.comment += " " + bookingsImportByXls[i]["Commentaires"];
                                        else
                                            booking.comment = bookingsImportByXls[i]["Commentaires"];
                                    booking.price += bookingService.price;
                                    if (booking.period && booking.bookingServices.length>0)
                                    {
                                        booking.globalDuration = 0;
                                        booking.price=0;
                                        var start = booking.bookingServices[0].period.start;
                                        var end = booking.bookingServices[0].period.end;
                                        booking.globalDuration +=booking.bookingServices[0].period.duration;
                                        booking.price +=booking.bookingServices[0].price;
                                        for (var l=1; l< booking.bookingServices.length;l++)
                                        {
                                            if ((booking.bookingServices[l].period.start.getTime())  < (start.getTime()))
                                                start = booking.bookingServices[l].period.start;
                                            if ((booking.bookingServices[l].period.end.getTime()) > (end.getTime()))
                                                end = booking.bookingServices[l].period.end;
                                            booking.globalDuration +=booking.bookingServices[l].period.duration;
                                            booking.price +=booking.bookingServices[l].price;
                                        }
                                        booking.period.setStart(start);
                                        booking.period.setEnd(end);
                                    }
                                    else
                                    {
                                        booking.period = new Period(bookingService.period);
                                        this.globalDuration =   booking.period.duration;
                                    }
                                }
                                else
                                    $scope.dd.view.logs.push({message:"Day incorrect or not found line n°" + i+ " " + bookingsImportByXls[i]["Date et heure de début"]});
                            }
                            else
                                $scope.dd.view.logs.push({message:"Service not found  line n°" + i+ " '" + bookingsImportByXls[i]["Rdv proposé"]+"'"});
                        }
                        else
                            $scope.dd.view.logs.push({message:"HumanResource not found  line n°" + i+ " '" + bookingsImportByXls[i]["Agenda"]+"'"});
                    }
                    else
                        $scope.dd.view.logs.push({message:"Customer not found  on line n°" + i+ " '" + cCustomerView.lastName + "' '" + cCustomerView.firstName + "' '"+cCustomerView.phone + "' '"+cCustomerView.email + "'"});
                }
            }
            $scope.dd.view.bookingsDisplayView = $scope.dd.view.bookingsImportView.slice(0,50);
            $scope.dd.view.waitingForLoading = false;
        }

        $scope.saveImportedBookingsView  = function()
        {
            var transaction = new Transaction();
            var compteur = 0;
            $scope.dd.view.saving = true;
            $scope.dd.view.savingNumber = $scope.dd.view.bookingsImportView.length;
            for (var i =0; i<$scope.dd.view.bookingsImportView.length ;i++)
            {
                transaction.addObject($scope.dd.view.bookingsImportView[i]);
                compteur++;
                if (compteur==30)
                {
                    BookingSrv.executeTransaction(transaction, function ()
                    {
                        $scope.dd.view.bookingsSavedView = $scope.dd.view.bookingsSavedView.concat(transaction.objects);
                        if (ServerSrv.nextSavesStack.length==1  )
                        {
                            $scope.dd.view.saving = false;
                        }
                    });
                    transaction = new Transaction();
                    compteur=0;
                }
            }
            BookingSrv.executeTransaction(transaction, function ()
            {
                $scope.dd.view.bookingsSavedView = $scope.dd.view.bookingsSavedView.concat(transaction.objects);
                if (ServerSrv.nextSavesStack.length==1  )
                {
                    $scope.dd.view.saving =false;
                }
            });
            $scope.dd.view.bookingsImportView = [];
            $scope.dd.view.bookingsDisplayView = [];
        }
    }]
);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/ImportCtrl.js